import React, { Component } from "react";
import axios from "axios";

class Projects extends Component {
  constructor(props) {
    super(props);
    this.state = { repos: [] };
  }

  componentDidMount() {
    try {
      this.getRepos();
    } catch (err) {
      console.log(err);
    }
  }

  async getRepos() {
    const res = await axios.get(
      "https://api.github.com/search/repositories?q=user:ChanchalaGorale",
      {
        params: {
          per_page: 100,
        },
        headers: {
          Authorization: `token aa4c8ad0c3149db5eee525b6b06084ab1b7bb1aa`,
        },
      }
    );
    this.setState({ repos: res.data.items });
  }

  renderRepo() {
    return this.state.repos.map((repo) => {
      return (
        <div key={repo.node_id} className="col">
          <div className="card text-center card-project">
            <h3 className="card-title">{repo.name}</h3>
            <p className="card-text">{repo.description}</p>
            <p className="card-text">
              <span>
                <i className="fas fa-code-branch"></i>
                &nbsp;{repo.forks}
              </span>
              <span>
                <i className="fas fa-star"></i>
                &nbsp;{repo.stargazers_count}
              </span>
            </p>
            <a href={repo.svn_url}>
              <button type="button" className="btn btn-primary">
                View project
              </button>
            </a>
          </div>
        </div>
      );
    });
  }

  render() {
    return (
      <div className="project-bg" id="project">
        <h1 className="project-heading">
          <button>
            <i className="fab fa-github"></i> Projects
          </button>
        </h1>
        <p className="project-subtitle">
          Total Projects: {this.state.repos.length}
        </p>

        <div className="row row-cols-1 row-cols-md-3 g-4">
          {this.renderRepo()}
        </div>
      </div>
    );
  }
}

export default Projects;
